import Box from "@mui/material/Box";
import { Grid2 } from "@mui/material";
import { Paths } from "components/common/navigation";
import UserSignatureModal from "components/settings/user/UserSignatureModal";
import { PasswordFormModal } from "components/settings/user/form/passwordForm";
import UserCard from "components/settings/user/list/userCard";
import { ACTION_STATES } from "core/actions";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Typography from "@mui/material/Typography";
import LoadingFullScreen from "components/common/LoadingFullScreen";
import PropTypes from "prop-types";

const MODALS = {
    SIGNATURE: "SIGNATURE",
    PASSWORD: "PASSWORD",
};
const initialModalOption = {
    type: null,
    id: null,
};
function Users({ loadList, listStatus, users }) {
    const navigate = useNavigate();
    const [modalOption, setModalOption] = useState(initialModalOption);

    useEffect(() => {
        loadList();
    }, [loadList]);

    const handleEdit = useCallback(
        (id) => {
            navigate(Paths.ADMIN_USER + "/" + id);
        },
        [navigate]
    );

    function onOpenChangePassword(id) {
        setModalOption({
            id: id,
            type: MODALS.PASSWORD,
        });
    }
    function handleCloseOptions() {
        setModalOption(initialModalOption);
    }
    function handleOpenSignature(id) {
        setModalOption({
            id,
            type: MODALS.SIGNATURE,
        });
    }
    const isPasswordOpen = modalOption.type === MODALS.PASSWORD && modalOption.id;
    const isSignatureOpen = modalOption.type === MODALS.SIGNATURE && modalOption.id;

    if (listStatus === ACTION_STATES.SUCCESS) {
        return (
            (<Grid2 container spacing={2}>
                {users.map((u) => {
                    return (
                        (<Grid2
                            key={u.id}
                            size={{
                                xs: 12,
                                sm: 6,
                                md: 4,
                                lg: 4,
                                xl: 3
                            }}>
                            <UserCard
                                user={u}
                                onOpenChangePassword={onOpenChangePassword}
                                onOpenSignature={handleOpenSignature}
                                onEdit={handleEdit}
                            />
                        </Grid2>)
                    );
                })}
                {isPasswordOpen && <PasswordFormModal id={modalOption.id} onClose={handleCloseOptions} />}
                {isSignatureOpen && <UserSignatureModal userId={modalOption.id} onClose={handleCloseOptions} />}
            </Grid2>)
        );
    }
    const loading = listStatus === ACTION_STATES.SEND;

    return loading ? (
        <LoadingFullScreen open loadingMessage={"Loading users"} />
    ) : (
        <Box>
            <Typography>Something failed. Please contact admin.</Typography>
        </Box>
    );
}

Users.propTypes = {
    loadList: PropTypes.func.isRequired,
    listStatus: PropTypes.string.isRequired,
    users: PropTypes.array.isRequired,
};

export default Users;
